<template>
  <svg
    class="ErrorIcon"
    width="31"
    height="30"
    viewBox="0 0 31 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M30.5001 15C30.5001 23.2843 23.7843 30 15.5001 30C7.21579 30 0.500061 23.2843 0.500061 15C0.500061 6.71573 7.21579 0 15.5001 0C23.7843 0 30.5001 6.71573 30.5001 15ZM7.99872 20.9988L13.9974 15.0001L7.99872 9.00138L9.50132 7.49878L15.5 13.4975L21.4987 7.49878L23.0013 9.00138L17.0026 15.0001L23.0013 20.9988L21.4987 22.5014L15.5 16.5027L9.50132 22.5014L7.99872 20.9988Z"
      fill="#C33B2E"
    />
  </svg>
</template>

<script>
export default {
  name: 'ErrorIcon',
};
</script>

<style lang="scss" scoped>
.ErrorIcon {
  width: 100%;
  height: auto;
  fill: currentcolor;
}
</style>
